export const SET_ADDRESS = "SET_ADDRESS";
export const SET_CITY = "SET_CITY";
export const SET_STATE_NAME = "SET_STATE_NAME";
export const SET_BVN_ID = "SET_BVN_ID";
export const SET_KYC_DOCS = "SET_KYC_DOCS";
export const SUPPORT_MAIL = "SUPPORT_MAIL";
export const CHARGE_BACK_MAIL = "CHARGE_BACK_MAIL";
export const BUSINESS_MAIL = "BUSINESS_MAIL";
export const BANK = "BANK";
export const ACCOUNT_NUMBER = "ACCOUNT_NUMBER";
export const RESET_FORM = "RESET_FORM";
export const BANK_NAME = "BANK_NAME";

export const updateAddress = (address) => ({
  type: SET_ADDRESS,
  payload: address,
});

export const updateCity = (city) => ({
  type: SET_CITY,
  payload: city,
});

export const updateStateName = (stateName) => ({
  type: SET_STATE_NAME,
  payload: stateName,
});

export const updateBvnId = (bvnId) => ({
  type: SET_BVN_ID,
  payload: bvnId,
});

export const updateKycDocuments = (value) => ({
  type: SET_KYC_DOCS,
  payload: value,
});

export const updateSupportMail = (supportEmail)=>({
  type: SUPPORT_MAIL,
  payload: supportEmail
})

export const updateBusinessMail = (businessEmail) => ({
  type: BUSINESS_MAIL,
  payload: businessEmail,
})

export const updateChargeBackMail = (chargeBackEmail) => ({
  type: CHARGE_BACK_MAIL,
  payload: chargeBackEmail,
});

export const updateBank = (selectedBank) => ({
  type: BANK,
  payload: selectedBank,
});

export const updateAccountNumber = (accountNum) => ({
  type: ACCOUNT_NUMBER,
  payload: accountNum,
});

export const updateBankName = (selectedBankName)=>({
  type: BANK_NAME,
  payload: selectedBankName
})
